app.factory('legalBarService', function($sessionStorage) {
    var storage = $sessionStorage.$default({
        isLegalBarVisible: true,
        isLangVisible: true
    });

    return {
        get isVisible() {
            return storage.isLegalBarVisible;
        },
        get isLangVisible() {
            return storage.isLangVisible;
        },
        set isVisible(isVisible) {
            storage.isLegalBarVisible = !!isVisible;
        },
        set isLangVisible(isVisible) {
            storage.isLangVisible = !!isVisible;
        },
        toggle: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }

            this.isVisible = !this.isVisible;
        },
        toggleLang: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }

            this.isLangVisible = !this.isLangVisible;
        },
        show: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }

            this.isVisible = true;
        },
        hide: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }

            this.isVisible = false;
        },
        hideLang: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }

            this.isLangVisible = false;
        },
        changeLang: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }

            this.isLangVisible = false;
            const lang = document.querySelector('#langs').value;

            if (lang && lang.toLowerCase().includes('eur')) {
                localStorage.setItem('currency', 'EUR');
            } else if (lang && lang.toLowerCase().includes('uni')) {
                localStorage.setItem('currency', 'DOLLARS');
            } else {
                localStorage.setItem('currency', 'CAD');
            }

            if (lang && lang.toLowerCase().includes('fr')) {
                document.location.href = '/fr';
            } else {
                document.location.href = '/';
            }
        }
    };
});
